// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from List.module.scss  */
ul.List-module-Root_1dJ {
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 0;
  list-style-type: none; }

.List-module-isFilled_2lE {
  border-radius: var(--list-border-radius);
  background-color: var(--list-background-color); }

.List-module-isOutlined_1_B {
  border: 1px solid var(--list-border-color);
  border-radius: var(--list-border-radius); }

.List-module-isFilled_2lE,
.List-module-isOutlined_1_B {
  box-sizing: border-box; }
  .List-module-isFilled_2lE [role='listitem'],
  .List-module-isOutlined_1_B [role='listitem'] {
    box-sizing: border-box;
    padding: 16px; }
    .List-module-isFilled_2lE [role='listitem'] label,
    .List-module-isOutlined_1_B [role='listitem'] label {
      padding-top: 0;
      padding-bottom: 0; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/List/List.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,qBAAqB,EAAE;;AAEzB;EACE,wCAAwC;EACxC,8CAA8C,EAAE;;AAElD;EACE,0CAA0C;EAC1C,wCAAwC,EAAE;;AAE5C;;EAEE,sBAAsB,EAAE;EACxB;;IAEE,sBAAsB;IACtB,aAAa,EAAE;IACf;;MAEE,cAAc;MACd,iBAAiB,EAAE","sourcesContent":["/*  imported from List.module.scss  */\nul.List-module-Root_1dJ {\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style-type: none; }\n\n.List-module-isFilled_2lE {\n  border-radius: var(--list-border-radius);\n  background-color: var(--list-background-color); }\n\n.List-module-isOutlined_1_B {\n  border: 1px solid var(--list-border-color);\n  border-radius: var(--list-border-radius); }\n\n.List-module-isFilled_2lE,\n.List-module-isOutlined_1_B {\n  box-sizing: border-box; }\n  .List-module-isFilled_2lE [role='listitem'],\n  .List-module-isOutlined_1_B [role='listitem'] {\n    box-sizing: border-box;\n    padding: 16px; }\n    .List-module-isFilled_2lE [role='listitem'] label,\n    .List-module-isOutlined_1_B [role='listitem'] label {\n      padding-top: 0;\n      padding-bottom: 0; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
